import React from "react";
import { Button, Link } from "@chakra-ui/react";

interface Props {
  href: string;
  label: string;
  // 새 창 안내 접근성 이름 접미사 (예: "새 창 열림")
  newWindowLabel: string;
  onOpen: () => void;
  isPrimary?: boolean;
}

/**
 * 가이드의 외부 이동 버튼.
 *
 * `window.open` 대신 실제 `<a href>` 로 둔다 — 가운데 클릭·링크 복사가 되고
 * 스크린리더에도 링크로 읽힌다(데모와 같은 구조). 열었다는 사실은 onOpen 이 기록한다.
 */
function PathPickStartGuideExternalLink({
  href,
  label,
  newWindowLabel,
  onOpen,
  isPrimary = true,
}: Props) {
  return (
    <Button
      as={Link}
      href={href}
      isExternal={true}
      // Chakra Link 의 isExternal 이 rel 을 붙이지만 명시해 둔다.
      rel={"noopener noreferrer"}
      aria-label={`${label} (${newWindowLabel})`}
      onClick={onOpen}
      size={"sm"}
      height={"28px"}
      borderRadius={"4px"}
      paddingInline={"12px"}
      textStyle={"body-sm-bold"}
      fontSize={"12px"}
      color={isPrimary ? "#FFFFFF" : "#444440"}
      backgroundColor={isPrimary ? "#1272EF" : "#FCFCFB"}
      border={isPrimary ? "none" : "0.5px solid #8F8F8C"}
      boxShadow={"1px 2px 4px 0px rgba(0, 0, 0, 0.1)"}
      _hover={{
        textDecoration: "none",
        backgroundColor: isPrimary ? "#005AAD" : "#FCFCFB",
        color: isPrimary ? "#FFFFFF" : "#1272EF",
      }}
    >
      {label}
    </Button>
  );
}

export default PathPickStartGuideExternalLink;
